import { render } from "./chartPrice.vue?vue&type=template&id=3305199e&ts=true"
import script from "./chartPrice.vue?vue&type=script&lang=ts"
export * from "./chartPrice.vue?vue&type=script&lang=ts"

import "./chartPrice.vue?vue&type=style&index=0&id=3305199e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__